import React from 'react'
import {
  Select,
  MenuItem,
  FormControl,
  Box,
  Typography,
  IconButton,
} from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { makeStyles } from '../../utils/hooks/makeStyles'

const useStyles = makeStyles((theme) => ({
  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    boxSizing: 'border-box',
    border: '1px solid lightgrey',
    background: 'white',
    height: '35px',
    padding: '0 8px',
  },
  rowsPerPageBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  rowsPerPageText: {
    fontSize: '12px',
  },
  select: {
    fontSize: '12px',
    height: '28px',
    '& .MuiSelect-select': {
      padding: '4px 8px',
    },
  },
  paginationBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  pageCount: {
    fontSize: '12px',
    minWidth: '30px',
    textAlign: 'center',
  },
  navButton: {
    padding: '4px',
    '&:disabled': {
      opacity: 0.3,
    },
  },
}))

interface PatientNavigationProps {
  page: number
  setPage: (page: number) => void
  size: number
  setSize: (size: number) => void
  count: number
  pageSizeOptions?: number[]
}

const PatientNavigation: React.FC<PatientNavigationProps> = ({
  page,
  setPage,
  size,
  setSize,
  count,
  pageSizeOptions = [10, 20, 50, 100],
}) => {
  const classes = useStyles()

  // Calculate total pages from total elements and page size
  const totalPages = Math.ceil(count / size)

  const handlePrevious = () => {
    if (page > 0) {
      setPage(page - 1)
    }
  }

  const handleNext = () => {
    if (page < totalPages - 1) {
      setPage(page + 1)
    }
  }

  const handleSizeChange = (event: any) => {
    setSize(event.target.value)
    setPage(0) // Reset to first page when changing page size
  }

  return (
    <div className={classes.navigationContainer}>
      <Box className={classes.rowsPerPageBox}>
        <Typography variant='caption' className={classes.rowsPerPageText}>
          Rows per page:
        </Typography>
        <FormControl size='small'>
          <Select
            value={size}
            onChange={handleSizeChange}
            className={classes.select}
          >
            {pageSizeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box className={classes.paginationBox}>
        <IconButton
          onClick={handlePrevious}
          disabled={page === 0}
          className={classes.navButton}
          size='small'
        >
          <ChevronLeft fontSize='small' />
        </IconButton>
        <Typography variant='caption' className={classes.pageCount}>
          {page + 1} / {totalPages}
        </Typography>
        <IconButton
          onClick={handleNext}
          disabled={page >= totalPages - 1}
          className={classes.navButton}
          size='small'
        >
          <ChevronRight fontSize='small' />
        </IconButton>
      </Box>
    </div>
  )
}

export default PatientNavigation
